export const only = (array) => {
  return array && array.length > 0 ? array[0] : {}
}